// extracted by mini-css-extract-plugin
module.exports = {"loadingDots":"loader_loadingDots__GHkO5","loadingDot":"loader_loadingDot__Guuiy","dot-keyframes":"loader_dot-keyframes__Gy6dm"};